export default function UserContextProvider() {
    throw new Error('This should not be called if using Auth0.');
}
